/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Empty/Doctor/Content",
  isInvalid,
  onChange
  
}) {
let dentalMonitoringDoctorsValueData = fromData.useDataValue({ viewPath,
context: 'dental_monitoring_doctors',
})
let selectedDoctorIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'doctor_id',
})
let selectedDoctorIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'selected',
path: 'doctor_id',
validate: fromValidate.uuid,
required: true,
})
let selectedDoctorIdChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'doctor_id',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 size="medium"
 maxWidth={240}
 data="dental_monitoring_doctors"
 from={dentalMonitoringDoctorsValueData}
 data="selected.doctor_id"
 validate="/Data/validate.js uuid"
 invalid={!selectedDoctorIdIsValidData}
 required={true}
 value={selectedDoctorIdValueData}
 onChange={selectedDoctorIdChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Provider"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}